import { render, staticRenderFns } from "./SubscriptionManagerTag.vue?vue&type=template&id=0a3aa477&scoped=true"
import script from "./SubscriptionManagerTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionManagerTag.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SubscriptionManagerTag.vue?vue&type=style&index=0&id=0a3aa477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3aa477",
  null
  
)

export default component.exports